import ExerciseVideoIssueChip from './ExerciseVideoIssueChip';

export default ExerciseVideoIssueChip;
